import axios from "../utils/axios";

export class AppointmentStatusService {
  getAllAppointmentStatus() {
    return axios.get("/appointment-status");
  }
  createStatus(data: any) {
    return axios.post("/appointment-status", data);
  }
  updateStatus(id: string, payload: any) {
    return axios.put(`/appointment-status/${id}`, payload);
  }

  deleteStatus(id: string) {
    return axios.delete(`/appointment-status/${id}`);
  }
}
